export default __webpack_public_path__ + "static/media/audio.12ff3f91.mp3";